import React,{ useEffect, useState } from 'react';
import './index.scss';
import {Typography,notification,Modal,Select, Skeleton,} from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';

import API_SERVICE from 'shared/services/api-service';
import { getImageUrl, UploadImage } from 'shared/services/Utility';

import 'react-quill/dist/quill.snow.css';
import { fillEn } from 'client/src/methods/forms';
import Parameters from 'shared/parameters';
import breadcrumbArrow from '../../../src/img/breadcrumb-arrow.png';
interface Props {
    location: any;
    hideHeader?: boolean;
}
const { confirm } = Modal;
const { Title } = Typography;
const { Option } = Select;
export default function HowItWorks() {
    const { t } = useTranslation();
    
    return (
        <div className="container-fluid bg-white pt-5 pb-5 plr-4rem">
				<h4>{t('genDict.reviews')}</h4>
				<p className="mb-0">{t('genDict.WhatOurStudentsaying')}</p>
				<div className="row">
					<div className="col-md-4 col-sm-12 mt-4">
						<div className="bg-F9FAFB pl-4 pr-4 pt-3 pb-3 br-5px  light-shadow">
							<blockquote className="review">
								<p className="mb-2"><strong>{t('genDict.reviewParagraph')}</strong></p>
								<p>{t('genDict.reviewParagraph1')}</p>
								<div className="mt-4 d-flex align-items-center justify-content-space-between">
									<div className="d-flex align-items-center">
										<img src="assets/img/review-user.png" className="w-55"/>
										<span className="ml-2">{t('genDict.AnishaParveen')}</span>
									</div>
									<div className="d-flex align-items-center">
										<img src="assets/img/star-fill.png" style={{width:"14px"}} />
										<span className="ml-2">4.2</span>
									</div>
								</div>
							</blockquote>
						</div>
					</div>
					<div className="col-md-4 col-sm-12 mt-4">
						<div className="bg-F9FAFB pl-4 pr-4 pt-3 pb-3 br-5px  review-shadow">
							<blockquote className="review">
								<p className="mb-2"><strong>{t('genDict.reviewParagraph')}</strong></p>
								<p>{t('genDict.reviewParagraph1')}</p>
								<div className="mt-4 d-flex align-items-center justify-content-space-between">
									<div className="d-flex align-items-center">
										<img src="assets/img/review-user.png" className="w-55"/>
										<span className="ml-2">{t('genDict.AnishaParveen')}</span>
									</div>
									<div className="d-flex align-items-center">
										<img src="assets/img/star-fill.png" style={{width:"14px"}} />
										<span className="ml-2">4.2</span>
									</div>
								</div>
							</blockquote>
						</div>
					</div>
					<div className="col-md-4 col-sm-12 mt-4">
						<div className="bg-F9FAFB pl-4 pr-4 pt-3 pb-3 br-5px  review-shadow">
							<blockquote className="review">
								<p className="mb-2"><strong>{t('genDict.reviewParagraph')}</strong></p>
								<p>{t('genDict.reviewParagraph1')}</p>
								<div className="mt-4 d-flex align-items-center justify-content-space-between">
									<div className="d-flex align-items-center">
										<img src="assets/img/review-user.png" className="w-55"/>
										<span className="ml-2">{t('genDict.AnishaParveen')}</span>
									</div>
									<div className="d-flex align-items-center">
										<img src="assets/img/star-fill.png" style={{width:"14px"}} />
										<span className="ml-2">4.2</span>
									</div>
								</div>
							</blockquote>
						</div>
					</div>
					<div className="col-md-4 col-sm-12 mt-4">
						<div className="bg-F9FAFB pl-4 pr-4 pt-3 pb-3 br-5px  review-shadow">
							<blockquote className="review">
								<p className="mb-2"><strong>{t('genDict.reviewParagraph')}</strong></p>
								<p>{t('genDict.reviewParagraph1')}</p>
								<div className="mt-4 d-flex align-items-center justify-content-space-between">
									<div className="d-flex align-items-center">
										<img src="assets/img/review-user.png" className="w-55"/>
										<span className="ml-2">{t('genDict.AnishaParveen')}</span>
									</div>
									<div className="d-flex align-items-center">
										<img src="assets/img/star-fill.png" style={{width:"14px"}} />
										<span className="ml-2">4.2</span>
									</div>
								</div>
							</blockquote>
						</div>
					</div>
					<div className="col-md-4 col-sm-12 mt-4">
						<div className="bg-F9FAFB pl-4 pr-4 pt-3 pb-3 br-5px  review-shadow">
							<blockquote className="review">
								<p className="mb-2"><strong>{t('genDict.reviewParagraph')}</strong></p>
								<p>{t('genDict.reviewParagraph1')}</p>
								<div className="mt-4 d-flex align-items-center justify-content-space-between">
									<div className="d-flex align-items-center">
										<img src="assets/img/review-user.png" className="w-55"/>
										<span className="ml-2">{t('genDict.AnishaParveen')}</span>
									</div>
									<div className="d-flex align-items-center">
										<img src="assets/img/star-fill.png" style={{width:"14px"}} />
										<span className="ml-2">4.2</span>
									</div>
								</div>
							</blockquote>
						</div>
					</div>
					<div className="col-md-4 col-sm-12 mt-4">
						<div className="bg-F9FAFB pl-4 pr-4 pt-3 pb-3 br-5px  review-shadow">
							<blockquote className="review">
								<p className="mb-2"><strong>{t('genDict.reviewParagraph')}</strong></p>
								<p>{t('genDict.reviewParagraph1')}</p>
								<div className="mt-4 d-flex align-items-center justify-content-space-between">
									<div className="d-flex align-items-center">
										<img src="assets/img/review-user.png" className="w-55"/>
										<span className="ml-2">{t('genDict.AnishaParveen')}</span>
									</div>
									<div className="d-flex align-items-center">
										<img src="assets/img/star-fill.png" style={{width:"14px"}} />
										<span className="ml-2">4.2</span>
									</div>
								</div>
							</blockquote>
						</div>
					</div>
				</div>
			</div>
        
    )
}